import * as React from 'react';
import { ArrowDownS16, ArrowUpS16 } from '@cian/ui-kit/icons';
import { Header4, InlineText1 } from '@cian/ui-kit/typography';

import { IFlatOffers } from '../../../../types/offers';
import { HoveredLink } from '../../../HoveredLink';
import { OffersLayoutList } from '../OffersLayoutList';

import * as styles from './styles.css';

interface IOffersRowProps extends IFlatOffers {
  displayHouseName?: boolean;
  onRoomTypeLinkClick(label: string): void;
  onOfferLinkClick(offerId: number, gaLabel: string): void;
  onOffersQuantityLinkClick(roomType: string): void;
}

export function OffersRow({
  roomTypeDisplay,
  totalAreaMinDisplay,
  price2Range,
  fromDeveloperPropsCountDisplay,
  fromDeveloperPropsCount,
  offersUrl,
  layouts,
  displayHouseName,
  roomType,
  onRoomTypeLinkClick,
  onOfferLinkClick,
  onOffersQuantityLinkClick,
}: IOffersRowProps) {
  const [expanded, changeExpandedState] = React.useState(false);
  const toggleExpand = React.useCallback(() => {
    changeExpandedState(!expanded);
    onOffersQuantityLinkClick(roomType);
  }, [expanded]);
  const ArrowIcon = expanded ? ArrowUpS16 : ArrowDownS16;

  return (
    <div className={styles['container']}>
      <div className={styles['row']}>
        <div className={styles['room-type']}>
          <HoveredLink
            url={offersUrl}
            childNode={Header4}
            as="h4"
            color="black_100"
            onClick={() => onRoomTypeLinkClick(roomType)}
          >
            {roomTypeDisplay}
          </HoveredLink>
        </div>
        <div>
          <InlineText1 color="gray60_100">{totalAreaMinDisplay}</InlineText1>
        </div>
        <div className={styles['price']}>
          <InlineText1 color="black_100">{price2Range}</InlineText1>
        </div>
        <div className={styles['props-count']}>
          <div onClick={toggleExpand}>
            <InlineText1 color="primary_100">{fromDeveloperPropsCountDisplay}</InlineText1>
            <div className={styles['arrow']}>
              <ArrowIcon color="primary_100" />
            </div>
          </div>
        </div>
      </div>
      <OffersLayoutList
        expanded={expanded}
        offersUrl={offersUrl}
        layouts={layouts}
        displayHouseName={displayHouseName}
        fromDeveloperPropsCount={fromDeveloperPropsCount}
        onAllOffersLinkClick={() => onRoomTypeLinkClick(roomType)}
        onOfferLinkClick={onOfferLinkClick}
      />
    </div>
  );
}
